var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import dayjs from "dayjs";
import { createApp, defineComponent, onMounted, reactive, ref, watch, nextTick, } from "vue";
import { forms } from "../../types/front/TOrderForm";
import cart from "../_component/Cart";
import timezone from "dayjs/plugin/timezone.js";
import utc from "dayjs/plugin/utc";
import _ from "lodash"; // 配列操作外部ライブラリ
import axios from "axios";
import Event_ from "../../models/Event";
const App = defineComponent({
    setup() {
        dayjs.extend(timezone);
        dayjs.extend(utc);
        dayjs.tz.setDefault("Asia/Tokyo");
        let arrive_at = reactive({ year: "", month: "", day: "", value: "" });
        let event = reactive([new Event_()]);
        let event_at = { year: "", month: "", day: "", text: "" };
        let data = ref();
        let orders = forms;
        let refForm = ref();
        let checkRedirectLogin = null;
        const STORAGE_ORDER_PLAN = "orders_plan";
        let print_color = {};
        let print_paper = {};
        let paper_coating = [];
        let color_tones = [];
        let paper_sizes = [];
        let additionals = [];
        let plans = ref([]);
        let next_page_url = ref("");
        let current_page_url = "";
        onMounted(() => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
            next_page_url.value =
                (_b = JSON.parse(((_a = data.value) === null || _a === void 0 ? void 0 : _a.getAttribute("next_page_url")) || "[]")) !== null && _b !== void 0 ? _b : [];
            print_color =
                (_d = JSON.parse(((_c = data.value) === null || _c === void 0 ? void 0 : _c.getAttribute("print_color")) || "[]")) !== null && _d !== void 0 ? _d : [];
            print_paper =
                (_f = JSON.parse(((_e = data.value) === null || _e === void 0 ? void 0 : _e.getAttribute("print_paper")) || "[]")) !== null && _f !== void 0 ? _f : [];
            paper_coating =
                (_h = JSON.parse(((_g = data.value) === null || _g === void 0 ? void 0 : _g.getAttribute("paper_coating")) || "[]")) !== null && _h !== void 0 ? _h : [];
            color_tones =
                (_k = JSON.parse(((_j = data.value) === null || _j === void 0 ? void 0 : _j.getAttribute("color_tones")) || "[]")) !== null && _k !== void 0 ? _k : [];
            paper_sizes = JSON.parse(((_l = data.value) === null || _l === void 0 ? void 0 : _l.getAttribute("paper_sizes")) || "[]");
            additionals = JSON.parse(((_m = data.value) === null || _m === void 0 ? void 0 : _m.getAttribute("additionals")) || "[]");
            orders = window._.merge(orders, reactive(JSON.parse(((_o = data.value) === null || _o === void 0 ? void 0 : _o.getAttribute("orders")) || "[]")));
            // 初期表示時イベント内容反映
            event = _.merge(event, reactive(JSON.parse(((_p = data.value) === null || _p === void 0 ? void 0 : _p.getAttribute("event")) || "[]")));
            if (orders[0].mode == "event" && event[0] != null) {
                onClickEvent({
                    id: event[0].id,
                    name: `${event[0].name}`,
                    trend: `${event[0].trend}`,
                    event_at: `${event[0].event_at}`,
                }, event[0].subdivisions[0]
                    ? {
                        id: event[0].subdivisions[0].id,
                        name: `${event[0].subdivisions[0].name}`,
                        trend: `${event[0].subdivisions[0].trend}`,
                    }
                    : undefined);
            }
            // イベント日程の場合
            if (orders[0].mode == "event" &&
                orders[0].plans[0].events[0].event_at) {
                // event_atも最終的にarrive_atに統合される
                orders[0].plans[0].arrive_at =
                    orders[0].plans[0].events[0].event_at = dayjs(orders[0].plans[0].events[0].event_at);
                const chk = document.getElementById("select-event");
                if (chk != null) {
                    chk.checked = true;
                }
            }
            else {
                // 納品日指定の場合
                orders[0].plans[0].arrive_at = dayjs(orders[0].plans[0].arrive_at);
                const chk = document.getElementById("select-other");
                if (chk != null) {
                    chk.checked = true;
                }
            }
            if (orders[0].plans[0].arrive_at) {
                arrive_at.year = orders[0].plans[0].arrive_at.format("YYYY");
                arrive_at.month = orders[0].plans[0].arrive_at.format("M");
                arrive_at.day = orders[0].plans[0].arrive_at.format("D");
            }
            // 選択処理
            // 用紙サイズ
            if (orders[0].plans[0].paper_sizes) {
                Object.values(paper_sizes).forEach((element) => {
                    if (element.id == orders[0].plans[0].paper_sizes[0].id) {
                        orders[0].plans[0].paper_sizes[0].name = element.name;
                    }
                });
            }
            // 印刷方式
            if (orders[0].plans[0].printing_methods) {
                orders[0].plans[0].printing_methods.forEach((element) => {
                    const chk = document.getElementById("print-method-" + element.id);
                    if (chk != null) {
                        chk.checked = true;
                    }
                });
            }
            //　製本方式
            if (orders[0].plans[0].binding_methods) {
                orders[0].plans[0].binding_methods.forEach((element) => {
                    const chk = document.getElementById("print-bind-" + element.id);
                    if (chk != null) {
                        chk.checked = true;
                    }
                });
            }
            // 表紙色
            if (print_color["cover"] && print_color["cover"]["full"]) {
                const chk = document.getElementById("print-color-cover-full");
                if (chk != null) {
                    chk.checked = true;
                }
            }
            if (print_color["cover"] && print_color["cover"]["single"]) {
                const chk = document.getElementById("print-color-cover-single");
                if (chk != null) {
                    chk.checked = true;
                }
            }
            // 本文色
            if (print_color["body"] && print_color["body"]["full"]) {
                const chk = document.getElementById("print-color-body-full");
                if (chk != null) {
                    chk.checked = true;
                }
            }
            if (print_color["body"] && print_color["body"]["single"]) {
                const chk = document.getElementById("print-color-body-single");
                if (chk != null) {
                    chk.checked = true;
                }
            }
            // 表紙加工
            if (paper_coating) {
                Object.values(paper_coating).forEach((element) => {
                    const chk = document.getElementById("print-pp-" + element.id);
                    if (chk != null) {
                        chk.checked = true;
                    }
                });
            }
            // 遊び紙
            if (color_tones) {
                Object.values(color_tones).forEach((element) => {
                    const chk = document.getElementById("print-flyleaf-" + element.id);
                    if (chk != null) {
                        chk.checked = true;
                    }
                });
            }
            // 本文用紙:コミック
            if (print_paper["comic"]) {
                const chk = document.getElementById("print_paper_comic");
                if (chk != null) {
                    chk.checked = true;
                }
            }
            // 追加条件
            for (const prop in additionals) {
                const chk = document.getElementById("additionals-" + prop);
                if (chk != null) {
                    chk.checked = true;
                }
            }
            // ログイン後にリダイレクトしてきたか
            checkRedirectLogin = parseInt(JSON.parse(((_q = data.value) === null || _q === void 0 ? void 0 : _q.getAttribute("redirect")) || "0"));
            if (checkRedirectLogin) {
                // ログイン前の注文を取得反映
                orders = _.merge(orders, reactive(getOldOrderBeforeLogin()));
                localStorage.removeItem(STORAGE_ORDER_PLAN);
                // カートに注文を保存
                saveCartAfterLogin();
            }
            // 無限スクロール
            const options = {
                root: document,
                rootMargin: "0px",
                threshold: 0,
            };
            const observer = new IntersectionObserver(callback, options);
            const target = document.querySelector("#observer_target");
            observer.observe(target);
        });
        const callback = (entries) => {
            entries.forEach((entry) => {
                // 交差判定
                if (entry.isIntersecting) {
                    onScrollPagination();
                }
            });
        };
        // ページネーション無限スクロール
        const onScrollPagination = () => __awaiter(this, void 0, void 0, function* () {
            try {
                if (next_page_url.value &&
                    next_page_url.value != current_page_url) {
                    current_page_url = next_page_url.value;
                    const response = yield axios.get(next_page_url.value);
                    yield setNextPage(response.data);
                }
                else {
                    return false;
                }
            }
            catch (error) {
                console.log(error);
            }
            yield nextTick(() => {
                //印刷セット用アコーディオン
                const set_accordion_trigger = document.querySelectorAll(".set-accordion-trigger-add");
                set_accordion_trigger.forEach((trigger) => {
                    trigger.removeEventListener("click", accordionEvent, false);
                    trigger.addEventListener("click", accordionEvent, false);
                });
            });
            return false;
        });
        const setNextPage = (result) => {
            plans.value = [...plans.value, ...result];
            next_page_url.value = result[0].next_page_url;
            if (result[0].on_last_page) {
                next_page_url.value = null;
            }
        };
        const accordionEvent = (event) => {
            const accordion_trigger = event.target.parentNode.parentNode;
            accordion_trigger.classList.toggle("is-active");
            accordion_trigger.parentNode.nextElementSibling.classList.toggle("is-open");
            accordion_trigger.parentNode.parentNode.classList.toggle("is-active");
        };
        // ログイン処理前の注文をローカルストレージから取得
        const getOldOrderBeforeLogin = () => {
            let $orders = JSON.parse(localStorage.getItem(STORAGE_ORDER_PLAN) || "[]");
            return $orders;
        };
        // ログイン前の注文をカートに保存
        const saveCartAfterLogin = () => {
            orders[0].path_name = "front.specification.index";
            const planId = orders[0].plans[0].id;
            const node = document.querySelector(`input[name="orders[0][plans][0][id]"][value="${planId}"]`);
            cart.save(orders[0]).then((order) => {
                // @ts-ignore
                node.parentNode.parentNode.firstChild.firstChild.setAttribute("disabled", true);
                // @ts-ignore
                node.parentNode
                    .querySelector('input[name="orders[0][id]"]')
                    .setAttribute("value", order.id);
                const url = new URL(location.href);
                url.searchParams.delete("redirect");
                url.searchParams.delete("to");
                history.pushState(null, "", url);
                localStorage.removeItem(STORAGE_ORDER_PLAN);
            });
        };
        // 未ログイン時のカート保存処理(ローカルストレージに保存してログイン画面にリダイレクト)
        const onClickSaveCartNotLogin = (plan_id, price, $planPaperSizeId, $planPrintingMethodId, url_login) => {
            orders[0].plans[0].id = plan_id;
            orders[0].payments[0].price = price;
            orders[0].plans[0].paper_sizes[0].id = $planPaperSizeId;
            orders[0].plans[0].printing_methods[0].id = $planPrintingMethodId;
            orders[0].path_name = "front.specification.index";
            orders[0].type = "save_cart";
            orders[0].plans[0].forwardings[0].arrive_at = dayjs.tz(`${arrive_at.year}-${arrive_at.month}-${arrive_at.day} 09:00`, "Asia/Tokyo");
            localStorage.setItem(STORAGE_ORDER_PLAN, JSON.stringify(orders));
            setTimeout(() => {
                window.location.href = url_login;
            }, 1000);
        };
        // ログイン済みでのカート保存処理
        const onClickSaveInCart = (plan_id, price, $planPaperSizeId, $planPrintingMethodId, $event) => {
            orders[0].plans[0].id = plan_id;
            orders[0].payments[0].price = price;
            orders[0].plans[0].paper_sizes[0].id = $planPaperSizeId;
            orders[0].plans[0].printing_methods[0].id = $planPrintingMethodId;
            orders[0].path_name = "front.specification.index";
            orders[0].type = "save_cart";
            orders[0].plans[0].forwardings[0].arrive_at = dayjs.tz(`${arrive_at.year}-${arrive_at.month}-${arrive_at.day} 09:00`, "Asia/Tokyo");
            cart.saveMulti(orders[0]).then((order) => {
                $event.target.disabled = true;
                // $event.path[2].childNodes[1][0].value = order.id;
                alert("カートに保存しました");
            });
        };
        // ソート処理
        const onClickSort = (sort_by) => {
            let href = new URL(window.location.href);
            href.searchParams.set("sort_by", sort_by);
            window.location.href = href.toString();
        };
        // ↓↓↓詳細検索サイドバー↓↓↓
        // イベント日程/納品日程切り替えで、納品日切り替え
        watch(() => orders[0].plans[0].mode, (d) => {
            if (d === "event" && orders[0].plans[0].events[0].event_at) {
                orders[0].plans[0].forwardings[0].arrive_at = dayjs(orders[0].plans[0].events[0].event_at);
            }
            if (d === "other" && orders[0].plans[0].arrive_at) {
                orders[0].plans[0].forwardings[0].arrive_at = dayjs(orders[0].plans[0].arrive_at);
            }
        });
        // 納品日
        watch(() => arrive_at.value, (d) => {
            if (d) {
                orders[0].plans[0].arrive_at = dayjs(d);
                arrive_at.year = dayjs(orders[0].plans[0].arrive_at).format("YYYY");
                arrive_at.month = dayjs(orders[0].plans[0].arrive_at).format("MM");
                arrive_at.day = dayjs(orders[0].plans[0].arrive_at).format("DD");
                orders[0].plans[0].forwardings[0].arrive_at = dayjs(d);
            }
            else {
                orders[0].plans[0].forwardings[0].arrive_at = null;
            }
        });
        // イベント日程の変更と納品日への反映
        watch(() => orders[0].plans[0].events[0].event_at, (d) => {
            if (d) {
                event_at.year = dayjs(orders[0].plans[0].events[0].event_at).format("YYYY");
                event_at.month = dayjs(orders[0].plans[0].events[0].event_at).format("MM");
                event_at.day = dayjs(orders[0].plans[0].events[0].event_at).format("DD");
                event_at.text = dayjs(orders[0].plans[0].events[0].event_at).format("YYYY.MM.DD");
                // 最終的に次画面へ持っていく納品日
                orders[0].plans[0].forwardings[0].arrive_at = dayjs(d);
            }
            else {
                orders[0].plans[0].forwardings[0].arrive_at = null;
            }
        });
        // イベント日程
        const onClickEvent = (event, subdivision) => {
            orders[0].plans[0].events[0].id = event.id;
            orders[0].plans[0].events[0].name = event.name;
            orders[0].plans[0].events[0].trend = event.trend;
            if (event.event_at) {
                orders[0].plans[0].events[0].event_at = dayjs(event.event_at);
            }
            // ジャンルがある場合
            if (subdivision) {
                orders[0].plans[0].events[0].subdivisions[0].id =
                    subdivision.id;
                orders[0].plans[0].events[0].subdivisions[0].name =
                    subdivision.name;
                orders[0].plans[0].events[0].subdivisions[0].trend =
                    subdivision.trend;
            }
            else {
                orders[0].plans[0].events[0].subdivisions[0].id = null;
                orders[0].plans[0].events[0].subdivisions[0].name = null;
                orders[0].plans[0].events[0].subdivisions[0].trend = null;
            }
        };
        // 印刷業者変更
        const onClickContractor = (id, name) => {
            orders[0].plans[0].contractors[0].id = id;
            orders[0].plans[0].contractors[0].trade_name = name;
        };
        // 用紙サイズ変更
        const onClickPaperSize = (id, name) => {
            orders[0].plans[0].paper_sizes[0].id = id;
            orders[0].plans[0].paper_sizes[0].name = name;
        };
        // ページ変更
        const onClickPage = (value) => {
            orders[0].plans[0].pages[0].value = value;
        };
        // 部数変更
        const onClickLot = (value) => {
            orders[0].plans[0].lots[0].value = value;
            orders[0].plans[0].forwardings[0].lot = value;
        };
        return {
            arrive_at,
            event_at,
            data,
            orders,
            refForm,
            onClickSort,
            onClickSaveInCart,
            onClickSaveCartNotLogin,
            onClickEvent,
            onClickContractor,
            onClickPaperSize,
            onClickPage,
            onClickLot,
            onScrollPagination,
            plans,
            next_page_url,
        };
    },
});
window.addEventListener("DOMContentLoaded", (ev) => {
    createApp(App).mount("#app");
});
